import React from 'react';
import { FormattedMessage } from 'react-intl';

export default {
  REMOVE_ADMIN_FROM_BO: <FormattedMessage id="remove-agent-from-bo" defaultMessage="Remove Admin From BO" />,
  REMOVE_ACCESS: <FormattedMessage id="remove-access-for-admin" defaultMessage="Remove access" />,
  CANCEL: <FormattedMessage id="cancel" defaultMessage="Cancel" />,
  CONFIRM: <FormattedMessage id="confirm" defaultMessage="Confirm" />,
  REMOVE_ADMIN: <FormattedMessage id="remove-agent" defaultMessage="Remove Admin" />,
  SELECT_BROKERAGE: <FormattedMessage id="select-brokerage" defaultMessage="Please select brokerage" />,
  ADD_ADMIN_ACCESS: <FormattedMessage id="add-admin-access" defaultMessage="Add admin access" />,
  ADD_ACCESS: <FormattedMessage id="add-access-for-admin" defaultMessage="Add access" />,
};
